import { createContext, useContext } from "react";
import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { ApiResponse } from "./models/ApiResponse";
import { Region } from "./models/Region";

const useRegions = () => {
    const { response, isLoading } =
        useAuthenticatedFetch<ApiResponse<Region[]>>("api/regions");

    return {
        regions: response?.content ?? [],
        isLoading,
    };
};

export type RegionsContextType = {
    regions: Region[];
    isLoading: boolean;
};

const RegionsContext = createContext<RegionsContextType>({
    regions: [],
    isLoading: true,
});

export const useRegionsContext: () => RegionsContextType = () =>
    useContext(RegionsContext);

export type RegionsContextProviderProps = {
    children: React.ReactNode;
};

export const RegionsContextProvider = ({
    children,
}: RegionsContextProviderProps) => {
    const { regions, isLoading } = useRegions();

    return (
        <RegionsContext.Provider
            value={{
                regions,
                isLoading,
            }}
        >
            {children}
        </RegionsContext.Provider>
    );
};
